(() => {
  const demo = document.querySelector('[data-nv-review-demo]');
  if (demo) {
    const result = demo.querySelector('[data-nv-demo-result]');
    const controls = Array.from(demo.querySelectorAll('input, textarea'));
    demo.addEventListener('input', () => { result.textContent = ''; });
    demo.addEventListener('change', () => {
      const chosen = demo.querySelector('input[name="nv_demo_rating"]:checked');
      demo.querySelectorAll('[data-nv-star]').forEach(star => {
        star.classList.toggle('is-selected', !!chosen && Number(star.dataset.nvStar) <= Number(chosen.value));
      });
      demo.querySelector('[data-nv-rating-output]').textContent = chosen ? chosen.getAttribute('aria-label') : '';
    });
    demo.querySelector('[data-nv-demo-check]').addEventListener('click', () => {
      const invalid = controls.find(control => !control.checkValidity());
      result.textContent = invalid ? demo.dataset.demoInvalid : demo.dataset.demoValid;
      if (invalid) { invalid.focus(); invalid.reportValidity(); }
    });
  }
  const summary = document.querySelector('[data-nv-review-summary]');
  const reviewLink = document.querySelector('.nv-review-link');
  if (summary && reviewLink) reviewLink.textContent = summary.textContent.trim();
  let lastProductTitle = '';
  const rememberProduct = (event) => {
    const trigger = event.target.closest('[data-add-to-cart], [data-product-form]');
    if (!trigger) return;
    const section = trigger.closest('.product-template__container');
    const title = section && section.querySelector('h1');
    if (title) lastProductTitle = title.textContent.trim();
  };
  document.addEventListener('click', rememberProduct, true);
  document.addEventListener('submit', rememberProduct, true);
  const popupTitle = document.querySelector('[data-cart-popup-title]');
  if (popupTitle) {
    new MutationObserver(() => {
      if (lastProductTitle && popupTitle.textContent.trim() !== lastProductTitle) {
        popupTitle.textContent = lastProductTitle;
      }
    }).observe(popupTitle, { childList: true, characterData: true, subtree: true });
  }
})();
